enum AgenticFinancialsChartCategory {
  Tasks = 'tasks',
  Users = 'users',
  Epics = 'epics',
  Initiatives = 'initiatives',
}

export { AgenticFinancialsChartCategory };
